import { render } from "./PostShortCard.vue?vue&type=template&id=dc4a24a6&scoped=true"
import script from "./PostShortCard.vue?vue&type=script&lang=js"
export * from "./PostShortCard.vue?vue&type=script&lang=js"

import "./PostShortCard.vue?vue&type=style&index=0&id=dc4a24a6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc4a24a6"]])

export default __exports__